import {
  URLAPI,
  STORES_ACCESS_PATH,
  STORE_ACCESS_CREATE_PATH,
  STORE_ACCESS_UPDATE_PATH,
} from "../config/index";
import { LOGOUT } from './users'
import axios from "axios";

const init = {
  _create_store_access: {
    data: {},
    status: 0,
    message: {},
  },
  _update_store_access: {
    data: {},
    status: 0,
    message: {},
  },

};

export const CREATE_STORE_ACCESS = "CREATE_STORE_ACCESS";
export const UPDATE_STORE_ACCESS = "UPDATE_STORE_ACCESS";

export const users_stores_access_module = (state = init, action) => {
  switch (action.type) {
    case CREATE_STORE_ACCESS:
      return {
        ...state,
        _create_store_access: action.payload,
      };
    case UPDATE_STORE_ACCESS:
      return {
        ...state,
        _update_store_access: action.payload,
      };
    case LOGOUT:
      return init;
    default:
      return state;
  }
};

export const createUserStoreAccess = (token, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.post(
      `${URLAPI}${STORE_ACCESS_CREATE_PATH}`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: CREATE_STORE_ACCESS,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: CREATE_STORE_ACCESS,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: CREATE_STORE_ACCESS,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const updateUserStoreAccess = (token, id, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.patch(
      `${URLAPI}${STORE_ACCESS_UPDATE_PATH}${id}/`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: UPDATE_STORE_ACCESS,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: UPDATE_STORE_ACCESS,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: UPDATE_STORE_ACCESS,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const searchUsersStoresAccess = async (token, paramsUrl) => {
  return await axios.get(`${URLAPI}${STORES_ACCESS_PATH}${paramsUrl}`, {
      headers: {
          Authorization: `Basic ${token}`,
      },
  });
}

export const clear_store_access = (type) => async (dispatch) => {
  dispatch({
    type: type,
    payload: {
      data: [],
      status: 0,
      message: {},
    },
  });
};
